import React from 'react';

import { Typography, makeStyles, createStyles } from '@material-ui/core';
import Page from '../../page/Page';
import CarrierList from './CarrierList';

const useStyles = makeStyles(() => createStyles({
  header: {
    paddingTop: '3rem',
    paddingBottom: '2rem',
  },
}));

const ShippingCarriersPage = () => {
  const classes = useStyles();

  return (
    <Page>
      <Typography variant="h3" className={classes.header}>Carriers</Typography>
      <CarrierList />
    </Page>
  );
};

export default ShippingCarriersPage;
